module.exports = __webpack_public_path__ + "static/img/plan.544681e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plan/plan.png
// module id = lUUE
// module chunks = 1